<template>
  <div class="flex">
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <!-- <div class="mr-1 mb-1 order-1">
      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        type="border"
        class="truncate"
        size="small"
        @click="handleServiceWithoutDevice"
        >{{ $t("customers.label.service_without_device") }}</vs-button
      >
    </div> -->
    <div class="mr-1 mb-1 order-1">
      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-tag"
        class="truncate"
        type="border"
        size="small"
        @click="
          $router.push({
            name: 'Create Ticket',
            params: { id: $route.params.id },
          })
        "
        >{{ $t("customers.label.create_ticket") }}</vs-button
      >
    </div>
    <div class="mr-1 mb-1 order-1">
      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-crosshair"
        type="border"
        class="truncate"
        size="small"
        @click="
          $router.push({ name: 'Buy Sim', params: { id: $route.params.id } })
        "
        >{{ $t("customers.label.BuySIM") }}</vs-button
      >
      <!-- @click="openServiceActivation = true" -->
    </div>
    <!-- <div
      class="mr-1 mb-1 order-1"
      v-if="
        clientDetail &&
        clientDetail.billingInfo &&
        clientDetail.billingInfo.type === 'Postpaid'
      "
    >
      <vs-button
        color="primary"
        icon-pack="feather"
        icon=""
        class="truncate"
        type="border"
        size="small"
        @click="handleMakePayment"
        >{{ $t("customers.label.make_payment") }}</vs-button
      >
    </div> -->
    <div
      class="mr-1 mb-1 order-1"
      v-if="
        clientDetail &&
        clientDetail.billingInfo &&
        clientDetail.billingInfo.type === 'Postpaid'
      "
    >
      <vs-button
        color="primary"
        icon-pack="feather"
        icon=""
        class="truncate"
        type="border"
        size="small"
        @click="$emit('orderChargingPopup')"
        >{{ $t("customers.label.on_demand_billing") }}</vs-button
      >
    </div>
    <div
      class="mr-1 mb-1 order-1"
      v-if="
        clientDetail &&
        clientDetail.billingInfo &&
        clientDetail.billingInfo.type === 'Prepaid'
      "
    >
      <vs-button
        color="primary"
        icon-pack="feather"
        icon=""
        class="truncate"
        type="border"
        size="small"
        @click="$emit('redeemPopup')"
        >{{ $t("customers.label.redeem_voucher") }}</vs-button
      >
    </div>
    <!-- <div
      class="mr-1 mb-1 order-1"
      v-if="
        clientDetail &&
        clientDetail.billingInfo &&
        clientDetail.billingInfo.type === 'Prepaid'
      "
    >
      <vs-button
        color="primary"
        icon-pack="feather"
        icon=""
        class="truncate"
        type="border"
        size="small"
        @click="$emit('renewalPopup')"
        >{{ $t("customers.label.renewal") }}</vs-button
      >
    </div> -->
    <div
      class="mr-1 mb-1 order-1"
      v-if="
        clientDetail &&
        clientDetail.billingInfo &&
        clientDetail.billingInfo.type === 'Prepaid'
      "
    >
      <vs-button
        color="primary"
        icon-pack="feather"
        icon=""
        class="truncate"
        type="border"
        size="small"
        @click="$emit('topUpPopup')"
        >{{ $t("customers.label.top_up") }}</vs-button
      >
    </div>
    <div
      class="mr-1 mb-1 order-1"
      v-if="
        clientDetail &&
        clientDetail.billingInfo &&
        clientDetail.billingInfo.type === 'Prepaid'
      "
    >
      <vs-button
        color="primary"
        icon-pack="feather"
        icon=""
        class="truncate"
        type="border"
        size="small"
        @click="$emit('recieverPopup')"
        >{{ $t("customers.label.BalanceTransfer") }}</vs-button
      >
    </div>
    <!-- <div class="mr-1 mb-1 order-1">
      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <vs-button
          color="primary"
          icon-pack="feather"
          type="border"
          icon="icon-more-vertical"
          class="truncate p-2"
          size="small"
        ></vs-button>
        <vs-dropdown-menu class="vx-navbar-dropdown">
          <ul style="min-width: 13rem">
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            >
              <div @click="$emit('orderChargingPopup')" class="ml-2">
                {{ $t("customers.label.order_charging") }}
              </div>
            </li>
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            >
              <span @click="$emit('redeemPopup')" class="ml-2">{{
                $t("customers.label.redeem")
              }}</span>
            </li>
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            >
              <div @click="$emit('depositPopup')" class="ml-2">
                {{ $t("Deposit") }}
              </div>
            </li>
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            >
              <div @click="$emit('recieverPopup')" class="ml-2">
                {{ $t("Balance Transfer") }}
              </div>
            </li>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div> -->
    <div class="mr-1 mb-1 order-1">
      <vs-button
        color="primary"
        icon-pack="feather"
        type="border"
        title="Refresh"
        icon="icon-refresh-ccw"
        class="truncate p-2"
        size="small"
        @click="getClient"
      ></vs-button>
    </div>
    <!-- <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.book_order')"
        :active.sync="serviceWD"
        class="popup-close"
      >
        <ValidationObserver ref="observer2">
          <form>
            <h5 class="service-heading">
              {{ $t("customers.label.order_details") }}
            </h5>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.order_date")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="order date"
                    :key="resetKey"
                  >
                    <datepicker
                      placeholder="Select Date"
                      v-model="planData[0].start_date"
                      class="mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.add_service")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="add service"
                    :key="resetKey"
                  >
                    <v-select
                      label="serviceCode"
                      v-model="clientServiceData[0].serviceId"
                      :options="serviceTepmletList"
                      placeholder="Select Service"
                      :reduce="(serviceCode) => serviceCode.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      @input="handlerServiceChange"
                      class="min-w-200 w-full"
                    >
                      <template slot="option" slot-scope="option"
                        >{{ option.serviceCode }} ---
                        {{ option.serviceDescription }}</template
                      >
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div
                class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 w-full"
                v-if="networkNodeActive"
              >
                <div class="dropdown-with-label" v-if="detailsdropdown">
                  <small class="date-label"
                    >{{ $t("customers.label.network_node")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="network node"
                    :key="resetKey"
                  >
                    <v-select
                      label="systemname"
                      v-model="networknode"
                      :options="networkNodeTemplate"
                      placeholder="Select One"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      @input="networkNodeSelect"
                      class="min-w-200 w-full"
                    >
                      <template slot="option" slot-scope="option">{{
                        option.systemname
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <vs-input
                  v-else
                  :label="$t('customers.label.network_node')"
                  v-model="networknode"
                  disabled
                  class="w-full mb-2 font-semibold starlabel"
                />
              </div>
            </div>
            <h5 class="service-heading">
              {{ $t("customers.label.plan_details") }}
            </h5>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.plan_list")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="plan list"
                    :key="resetKey"
                  >
                    <v-select
                      label="name"
                      v-model="planObj.planId"
                      :options="[{ name: 'Base Pack', id: 1 }]"
                      placeholder="Select One"
                      @input="callPlans"
                      :reduce="(name) => name.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label">{{
                    $t("customers.label.plan")
                  }}</small>
                  <v-select
                    label="planCode"
                    v-model="selectedPlan"
                    :options="planDataL"
                    @input="planSelectedInWD"
                    placeholder="Select Plan"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template slot="option" slot-scope="option"
                      >{{ option.planCode }} ---
                      {{ option.planDescription }}</template
                    >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="center mb-2">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="serviceWDActivationSubmit"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.submit") }}</vs-button
                >
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div> -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.make_payment')"
        :active.sync="makePaymentPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-1 mt-1">
              <!-- <div class="vx-col mb-2 w-full">
                <vs-radio
                  v-model="paymentMode"
                  vs-value="account"
                  class="mr-8"
                  >{{ $t("customers.label.account") }}</vs-radio
                >
                <vs-radio
                  v-model="paymentMode"
                  vs-value="invoice"
                  class="mr-8"
                  >{{ $t("customers.label.invoice") }}</vs-radio
                >
                <vs-radio v-model="paymentMode" vs-value="deposit">{{
                  $t("customers.label.deposit")
                }}</vs-radio>
              </div> -->
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.payment_date")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.payment_date')"
                    :key="resetKey"
                  >
                    <datepicker
                      name="start-date"
                      class="mb-2"
                      v-model="payment.paymentDate"
                    ></datepicker>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.payment_type")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.payment_type')"
                    :key="resetKey"
                  >
                    <v-select
                      label="mCodeValue"
                      v-model="payment.paymentType"
                      :options="templateData.data"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      @input="checkCheque(payment.paymentType)"
                      :reduce="(mCodeValue) => mCodeValue.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-col sm:w-1/2 mb-2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.amount')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.amount')"
                    class="w-full starlabel mb-2 font-semibold"
                    v-model="payment.amountPaid"
                    icon-no-border
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col sm:w-1/2 mb-2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.receipt_no')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.receipt_no')"
                    type="text"
                    class="w-full font-semibold mb-2 starlabel"
                    v-model="payment.receiptNo"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row" v-if="payment.isChequeSelected">
              <div class="vx-col sm:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.cheque_no')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.cheque_no')"
                    type="text"
                    class="w-full font-semibold mb-2 starlabel"
                    v-model="payment.chequeNo"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.bank_name')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.bank_name')"
                    type="text"
                    class="w-full font-semibold mb-2 starlabel"
                    v-model="payment.bankName"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div style="height: 20px" v-if="payment.isChequeSelected"></div>
            <div class="vx-row" v-if="payment.isChequeSelected">
              <div class="vx-col sm:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.branch_name')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.branch_name')"
                    type="text"
                    class="w-full font-semibold mb-2 starlabel"
                    v-model="payment.branchName"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.cheque_date")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.cheque_date')"
                    :key="resetKey"
                  >
                    <datepicker
                      name="start-date"
                      class="mb-2"
                      v-model="payment.chequeDate"
                    ></datepicker
                    ><span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold">{{
                  $t("customers.label.notes")
                }}</small>
                <vs-textarea v-model="payment.remarks" />
              </div>
            </div>
            <!-- <vs-checkbox
              v-if="paymentMode == 'invoice'"
              v-model="showInvoice"
              class="mb-3"
              >Show Invoice Details</vs-checkbox
            > -->
            <!-- <div class="vx-row" v-if="showInvoice && paymentMode == 'invoice'">
              <vs-table
                v-if="paymentMode == 'invoice'"
                class="w-full p-2"
                :data="inoviceList"
                multiple
                v-model="selectedInovice"
              >
                <template slot="thead">
                  <vs-th>{{ $t("customers.label.invoice_id") }}</vs-th>
                  <vs-th>{{ $t("customers.label.invoice_date") }}</vs-th>
                  <vs-th>{{ $t("customers.label.invoice_amount") }}</vs-th>
                  <vs-th>{{ $t("customers.label.due_amount") }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="transaction"
                    v-for="(transaction, index) in data"
                    v-if="transaction.dueAmount > 0"
                  >
                    <vs-td :data="transaction.id">{{ transaction.id }}</vs-td>
                    <vs-td :data="transaction.id">{{
                      transaction.billDate
                    }}</vs-td>
                    <vs-td :data="transaction.id">{{
                      transaction.amount
                    }}</vs-td>
                    <vs-td :data="transaction.id">{{
                      transaction.dueAmount
                    }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div> -->
            <!-- <vs-checkbox
              v-if="paymentMode == 'deposit'"
              v-model="showDeposit"
              class="mb-3"
              >Show Deposit Details</vs-checkbox
            > -->
            <!-- <div class="vx-row" v-if="showDeposit && paymentMode == 'deposit'">
              <vs-table
                class="w-full p-2"
                :data="templateData.depositDatas"
                v-model="selectedDeposit"
              >
                <template slot="thead">
                  <vs-th>{{ $t("customers.label.select") }}</vs-th>
                  <vs-th>{{ $t("customers.label.id") }}</vs-th>
                  <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
                  <vs-th>{{ $t("customers.label.debit_amount") }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="transaction"
                    v-for="(transaction, index) in data"
                  >
                    <vs-td>
                      <div>
                        <vs-checkbox
                          v-model="selectedDepositTransaction"
                          @change="updateAmount(transaction)"
                        ></vs-checkbox>
                      </div>
                    </vs-td>
                    <vs-td>{{ transaction.id }}</vs-td>
                    <vs-td>{{ transaction.transactionDate }}</vs-td>
                    <vs-td>{{ transaction.debitAmount }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div> -->
            <div class="center mt-4">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="makePayment"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.submit") }}</vs-button
                >
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>

    <ServiceActivationModal
      @networkActive="networkNodeActive = true"
      @initSetNetwork="setNetworkDetails"
      :openPopUp="openServiceActivation"
      :networkNodeActive="networkNodeActive"
      :detailsdropdown="detailsdropdown"
      :customerId="$route.params.id"
      @onclose="openServiceActivation = false"
      @onSuccess="openServiceActivation = false"
    />
  </div>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import { mapState } from "vuex";
import ServiceActivationModal from "@/components/customers/ServiceActivationModal.vue";

const planDataEmpty = {
  billAlign: false,
  autoRenew: "",
  planCode: "",
  contractPeriod: "",
  paytermCode: "",
  isNewplan: true,
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  start_date: moment().format("DD MMMM YYYY"),
};
const addPlanEmpty = {
  id: "",
  planCode: "",
  planDescription: "",
  planPoId: "",
  dealPoId: "",
  paytermCode: "",
  contractPeriod: 1,
  clientServiceId: "",
  billAlign: true,
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  start_date: "",
  isNewplan: true,
};
const paymentEmpty = {
  collectionby: "",
  paymentDate: moment().format("DD MMMM YYYY"),
  paymentType: "",
  amountPaid: "",
  receiptNo: "",
  isWallet: false,
  isChequeSelected: false,
  bankName: "",
  branchName: "",
  chequeNo: "",
  chequeDate: moment().format("DD MMMM YYYY"),
  notes: "",
  collectionId: "",
  collectionName: "",
  remarks: "",
};
export default {
  data() {
    return {
      // serviceWD: false,
      customerActivationPopup: false,
      openServiceActivation: false,
      // detailsdropdown: true,
      ticketPopup: false,
      // networkNodeActive: false,
      depositData: [],
      makePaymentPopup: false,
      // paymentMode: "account",
      payment: {
        ...paymentEmpty,
      },
      // selectedInovice: [],
      // selectedDeposit: [],
      // showInvoice: false,
      // showDeposit: true,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      resetKey: 0,
      serviceTepmletList: [],
      planData: [{ ...planDataEmpty }],
      addPlanObj: { ...addPlanEmpty },
      networknode: "",
      selectedPlan: {},
      networkNodeTemplate: [],
      clientServiceDetailsObj: {
        status: "new",
        parameterId: "",
        parameterValue: "",
      },
      clientServiceData: [
        {
          clientServiceDetails: [],
          serviceId: "",
          accountNo: "",
        },
      ],
      planObj: {
        planId: "",
        selectedPlans: [],
        startDate: moment().format("DD MMMM YYYY"),
      },
      activation: {
        loc: "",
        email: "",
        fullName: "",
        address: "",
        idProof: "",
        village: "",
        phone: "",
        CafId: "",
        idProofValue: "",
        city: "",
        addService: "",
        networkNode: "",
        serialNo: "",
        pairSerialNo: "",
        planlist: "",
        plan: "",
        serviceId: "",
        unitPrice: "",
        itemType: "",
        clientData: {},
        activationDate: moment().format("DD MMMM YYYY"),
      },
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ServiceActivationModal,
    Datepicker,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      planDataL: (state) => state.customer.plansCata,
      clientDetail: (state) => state.customer.clientDetailData,
      planDataList: (state) => state.customerActivation.planData,
      networkNodeData: (state) => state.customer.networkNodeTemplate,
      formattedDate: (state) => state.settings.selectedDateFormat,
      inoviceList: (state) => state.customerPayment.inoviceList,
      templateData: (state) => state.customerPayment.templateDataList,
    }),
    services() {
      return this.$store.getters["customer/getClientsServiceTemplate"];
    },
  },
  methods: {
    // handleServiceWithoutDevice() {
    //   this.resetKey++;
    //   this.serviceWD = true;
    // },
    handleEditContactpopup() {
      this.resetKey++;
      this.editContactpopup = true;
    },
    handleCreateTicket() {
      this.resetKey++;
      this.ticketPopup = true;
    },
    // networkNodeSelect() {
    //   if (this.detailsdropdown)
    //     this.clientServiceDetailsObj.parameterValue = this.networknode.id;
    // },
    async getTemplate() {
      try {
        await this.$store.dispatch("customer/setSaleTemplate");
        this.$store.dispatch("customer/setClientTemplate");
        this.$store.dispatch("customerActivation/setPlanData", {
          country: this.clientDetail.addresses[0].country,
          state: this.clientDetail.addresses[0].state,
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getServiceTemplate() {
      try {
        await this.$store.dispatch("customer/setClientServiceTemplate");
        this.serviceTepmletList = this.services;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPlanPacks() {
      await this.$store.dispatch("customer/getPlanPackAction");
    },
    async getSalesCategory() {
      try {
        const response = await this.$store.dispatch(
          "customer/setCustomerSales",
          {
            category: "Base+Pack",
          }
        );

        this.salePlanCategory = response.data.allPlanDatas;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async callPlans() {
      //  this.$store.dispatch("customer/setBasePlans");
      await this.$store.dispatch("customer/getPlanCatalogue", {
        id: this.planObj.planId,
        clientId: this.$route.params.id,
        serviceId: this.addPlanObj.clientServiceId,
      });
    },
    // handlerServiceChange(e) {
    //   this.activation.serviceId = e;
    //   this.getNetworkDetails();
    // },
    handleMakePayment() {
      this.resetKey++;
      this.makePaymentPopup = true;
    },
    async makePayment() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      // if (
      //   this.paymentMode == "invoice" &&
      //   (!this.selectedInovice.length ||
      //     this.selectedInovice[0].amount > this.payment.amountPaid)
      // ) {
      //   this.errorMessage =
      //     "Select an Invoice and make sure amount is greater or equal to invoice amount";
      //   this.warningPopup = true;
      // } else {
      try {
        // if (this.paymentMode == "account") {
        const paymentsObj = {
          paymentCode: this.payment.paymentType,
          amountPaid: this.payment.amountPaid,
          receiptNo: this.payment.receiptNo,
          remarks: this.payment.remarks,
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          paymentDate: this.payment.paymentDate,
          isSubscriptionPayment: false,
        };
        if (this.payment.isChequeSelected) {
          paymentsObj.isChequeSelected = true;
          paymentsObj.chequeNo = this.payment.chequeNo;
          paymentsObj.bankName = this.payment.bankName;
          paymentsObj.branchName = this.payment.branchName;
        }
        await this.$store.dispatch("customerPayment/makePaymentAction", {
          id: this.$route.params.id,
          data: paymentsObj,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Payment Done Successfully!",
          type: "success",
        });
        // } else if (this.paymentMode == "invoice") {
        //   const paymentsObj = {
        //     paymentCode: this.payment.paymentType,
        //     amountPaid: this.payment.amountPaid,
        //     receiptNo: this.payment.receiptNo,
        //     remarks: this.payment.remarks,
        //     locale: "en",
        //     dateFormat: "dd MMMM yyyy",
        //     invoiceId: this.selectedInovice[0].id,
        //     paymentDate: this.payment.paymentDate,
        //     isSubscriptionPayment: false,
        //   };
        //   if (this.payment.isChequeSelected) {
        //     paymentsObj.isChequeSelected = true;
        //     paymentsObj.chequeNo = this.payment.chequeNo;
        //     paymentsObj.bankName = this.payment.bankName;
        //     paymentsObj.branchName = this.payment.branchName;
        //   }
        //   let resp = await this.$store.dispatch(
        //     "customerPayment/makePaymentAction",
        //     {
        //       id: this.$route.params.id,
        //       data: paymentsObj,
        //     }
        //   );
        //   let amount = this.payment.amountPaid;
        //   let creditdistributions = [];

        //   for (let temp of this.selectedInovice) {
        //     if (amount >= temp.amount) {
        //       creditdistributions = [
        //         ...creditdistributions,
        //         {
        //           amount: temp.amount,
        //           clientId: parseInt(this.$route.params.id),
        //           invoiceId: temp.id,
        //           locale: "en",
        //           paymentId: resp.data.resourceId,
        //         },
        //       ];
        //       amount -= temp.amount;
        //     }
        //   }
        //   if (creditdistributions.length) {
        //     let payload = {
        //       avialableAmount: amount,
        //       creditdistributions: creditdistributions,
        //       locale: "en",
        //       paymentId: resp.data.resourceId,
        //     };
        //     await this.$store.dispatch(
        //       "customerPayment/creditDistributionAction",
        //       {
        //         id: this.$route.params.id,
        //         data: payload,
        //       }
        //     );
        //   }
        //   this.$swal({
        //     title: "Success",
        //     icon: "success",
        //     text: "Invoice Done Successfully!",
        //     type: "success",
        //   });
        // } else if (this.paymentMode == "deposit") {
        //   const newDeposit = {
        //     depositId: this.templateData.depositDatas[0].id,
        //     amount: this.templateData.depositDatas[0].debitAmount,
        //     clientId: Number(this.$route.params.id),
        //     locale: "en",
        //   };
        //   this.depositData.push(newDeposit);
        //   const paymentsObj = {
        //     paymentCode: this.payment.paymentType,
        //     amountPaid: this.payment.amountPaid,
        //     receiptNo: this.payment.receiptNo,
        //     remarks: this.payment.remarks,
        //     locale: "en",
        //     paymentType: "Deposit",
        //     deposit: this.depositData,
        //     dateFormat: "dd MMMM yyyy",
        //     paymentDate: this.payment.paymentDate,
        //     isSubscriptionPayment: false,
        //   };
        //   if (this.payment.isChequeSelected) {
        //     paymentsObj.isChequeSelected = true;
        //     paymentsObj.chequeNo = this.payment.chequeNo;
        //     paymentsObj.bankName = this.payment.bankName;
        //     paymentsObj.branchName = this.payment.branchName;
        //   }
        //   await this.$store.dispatch("customerPayment/makePaymentAction", {
        //     id: this.$route.params.id,
        //     data: paymentsObj,
        //   });
        //   this.$swal({
        //     title: "Success",
        //     icon: "success",
        //     text: "Deposited Successfully!",
        //     type: "success",
        //   });
        // }
        this.payment = { ...paymentEmpty };
        this.$emit("refreshPage");
        this.makePaymentPopup = false;
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
      // }
    },
    checkCheque(id) {
      for (let temp of this.templateData.data) {
        if (temp.id == id) {
          if (temp.mCodeValue === "Cheque") {
            this.payment.isChequeSelected = true;
          } else this.payment.isChequeSelected = false;
        }
      }
    },
    updateAmount(transaction) {
      if (this.selectedDepositTransaction) {
        this.payment.amountPaid = transaction.debitAmount;
      } else {
        this.payment.amountPaid = "";
      }
    },
    async paymentsTemplate() {
      try {
        // await this.$store.dispatch("entity/setPaymentsTemplate");
        await this.$store.dispatch(
          "customerPayment/setInoviceList",
          this.$route.params.id
        );
        await this.$store.dispatch(
          "customerPayment/getListTemplateAction",
          this.$route.params.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    // async getNetworkDetails() {
    //   try {
    //     await this.$store.dispatch(
    //       "customer/setClientNetworkTemplate",
    //       this.activation.serviceId
    //     );
    //     this.setNetworkDetails();
    //   } catch (error) {
    //     throw Error(
    //       error.message.errors[0].defaultUserMessage ||
    //         `Api failed with status code: ${error.message.httpStatusCode}`
    //     );
    //   }
    // },
    // setNetworkDetails() {
    //   if (this.networkNodeData.length) {
    //     this.networkNodeActive = true;
    //   } else {
    //     this.networkNodeActive = false;
    //   }
    //   if (this.networkNodeData[0].details) {
    //     this.networkNodeTemplate = this.networkNodeData[0].details;
    //     this.detailsdropdown = true;
    //   } else {
    //     this.networkNodeTemplate = this.networkNodeData[0];
    //     this.networknode = this.networkNodeData[0].detailValue;
    //     this.clientServiceDetailsObj.parameterValue =
    //       this.networkNodeData[0].id;
    //     this.detailsdropdown = false;
    //   }
    //   this.clientServiceDetailsObj.parameterId =
    //     this.networkNodeData[0].paramName;
    // },
    async getClient() {
      try {
        await this.$store.dispatch(
          "customer/setClientDetailData",
          this.$route.params.id
        );
        this.loc = this.clientDetail.accountInfo.office.id;
        await this.$store.dispatch(
          "customerMoreInfo/getAllClientDocumentsAction",
          this.$route.params.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async planSelectedInWD(selectedPlan) {
      await this.$store.dispatch(
        "customerActivation/setContractDetails",
        (this.planData[0].planCode = selectedPlan.id),
        (this.planData[0].contractPeriod = selectedPlan.contractPeriodId),
        (this.planData[0].paytermCode = selectedPlan.chargeCycle)
      );
    },
    // async serviceWDActivationSubmit() {
    //   const isValid = await this.$refs.observer2.validate();
    //   if (!isValid) return;

    //   this.clientServiceData[0].clientServiceDetails = [
    //     this.clientServiceDetailsObj,
    //   ];
    //   let postPayload = {
    //     clientData: [],
    //     clientServiceData: this.clientServiceData,
    //     planData: this.planData,
    //   };

    //   try {
    //     await this.$store.dispatch("customer/serviceWDActivationAction", {
    //       id: this.$route.params.id,
    //       data: postPayload,
    //     });
    //     this.serviceWD = false;
    //     this.$swal({
    //       title: "Success",
    //       icon: "success",
    //       text: "Service Without Device Activated Successfully!",
    //       type: "success",
    //     });

    //     this.getClient();
    //   } catch (e) {
    //     this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
    //       "The parameter",
    //       ""
    //     );
    //     this.warningPopup = true;
    //     this.errors = e.message.errors;
    //   }
    // },
  },
  watch: {
    makePaymentPopup(newValue) {
      if (newValue) {
        this.paymentsTemplate();
        this.errorMessage = "";
      }
    },
    customerActivationPopup(newval) {
      if (newval) {
        this.getServiceTemplate();
        this.getTemplate();
        this.getPlanPacks();
        this.getSalesCategory();
        this.clientServiceData[0].accountNo = this.clientDetail.accountNumber;
      }
    },
    ticketPopup(newval) {
      if (newval) {
        this.ticketTemplate();
        this.ticket.ticketDate = moment().format("DD MMMM YYYY");
        this.ticket.ticketTime = moment().format("hh:mm:ss A");
      }
    },
    "ticket.problemCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getSubCategory(this.ticket.problemCode);
      }
    },
  },
};
</script>
<style>
.vs-button.small.p-2 {
  padding: 1.2rem !important;
}
</style>
